import { render } from "./OcrReportValidationPanel.vue?vue&type=template&id=b6b14770"
import script from "./OcrReportValidationPanel.vue?vue&type=script&lang=js"
export * from "./OcrReportValidationPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__